import React from "react";
import EVLogo from "../assets/FPLEVolutionLogo_Horizontal_LeftJustified_2925.png";
import { Button } from "@mui/material";

export default function Header(props) {
  return (
    <div
      style={{
        top: 0,
        display: "flex",
        width: "100%",
        height: 75,
        backgroundColor: "white",
        alignItems: "center",
        boxShadow: "0px 3px 3px #dedede",
        zIndex: 100,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <div style={{ marginLeft: 30 }}>
          <img style={{ width: 175 }} src={EVLogo} alt="FPL EVolution" />
          <span
            style={{
              marginLeft: 25,
              marginRight: 25,
              color: "#C4C8C7",
              opacity: 0.5,
            }}
          >
            |
          </span>
          <span style={{ fontWeight: "bold", color: "#404040", fontSize: '17px' }}>
            Site Host Dashboard
          </span>
        </div>
        {props.auth ? (
          <Button
            onClick={props.signOut}
            style={{ marginRight: 30 }}
            className="logoutButton"
          >
            <span
              style={{ color: "#404040", fontWeight: "bold", fontSize: "15px" }}
            >
              Log Out
            </span>
          </Button>
        ) : //   <div style={{ marginRight: 30, cursor: 'pointer' }} onClick={handleLogOut}>
        //     <span
        //       style={{ color: "#404040", fontWeight: "bold", fontSize: "15px" }}
        //     >
        //       Log Out
        //     </span>
        //   </div>
        null}
      </div>
    </div>
  );
}
